<template>
  <div class="video-wrapper">
    <vue-plyr>
      <div class="plyr__video-embed">
        <iframe
          :src="videoSrc"
          loading="lazy"
          allowfullscreen
          allow="autoplay"
          title="video"
        ></iframe>
      </div>
    </vue-plyr>
  </div>
</template>

<script>
import Vue from "vue";
import VuePlyr from "vue-plyr";

Vue.use(VuePlyr);

export default {
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
  computed: {
    videoUrl() {
      return `https://www.youtube.com/embed/${this.videoId}`;
    },
    videoSrc() {
      return `${this.videoUrl}?origin=${window.location.href}&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`;
    },
  },
};
</script>

<style lang="scss">
.video-wrapper {
  max-width: 570px;
  min-width: 330px;
  padding: 0 20px;
  margin: 0 auto;

  .plyr__control[data-plyr="pip"] {
    display: none !important;
  }

  .plyr__video-wrapper {
    border-radius: 15px;
    padding-bottom: 0 !important;
  }

  .plyr__controls {
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .plyr__control--overlaid {
    border-radius: 50% !important;
  }
}

@media screen and(min-width: 768px) {
  .video-wrapper {
    padding: 0;
  }
}
</style>
